import { Suspense } from 'react';
import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import Loader from '../../globalComponents/loader/DPLoader';
import { DATA_INPUT_RULES, access } from '../../access';

const ManualSensors = withLazyLoading(() => import('../../pages/manualSensors'));

const manualInputRoutes = [
  {
    path: '/manual-sensors',
    handle: createCrumbHandle('Manual Sensors'),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <ManualSensors />
          </Suspense>
        ),
        handle: access(DATA_INPUT_RULES.templates),
      },
    ]
  },
];

export default manualInputRoutes;
